import React from 'react';

import { TabElem } from '../../common/tab';
import { FORM_VALUE_ENUM, tabList } from './constant';
import styled from 'styled-components';
import { Spacing } from '../../theme';
import { SelectElem } from '../../common/select';
import { FieldTimeInputElem } from '../../common/field-time-input';
import { customUserOption } from '../../data/user/option';

export const Component: React.FC<{
  activeTab: string;
  setActiveTab: Function;
  setUserId: Function;
  setEventId: Function;
  setDate: Function;
  userList: {
    label: string;
    value: string;
  }[];
  eventList: {
    label: string;
    value: string;
  }[];
  handleSelectUserChange: Function;
  handleSelectEventChange: Function;
}> = ({
  activeTab,
  setActiveTab,
  setDate,
  setUserId,
  setEventId,
  userList,
  eventList,
  handleSelectUserChange,
  handleSelectEventChange,
}) => {
  const onChangeTime = (_first: any, second: any) => {
    setDate(second);
  };

  const onChangeUser = (
    _e: any,
    data: {
      label: string;
      value: string;
    },
  ) => {
    setUserId(data?.value);
  };

  const onChangeEvent = (
    _e: any,
    data: {
      label: string;
      value: string;
    },
  ) => {
    setEventId(data?.value);
  };

  return (
    <Container>
      <TabElem active={activeTab} setActive={setActiveTab} tabList={tabList} />
      <Double>
        <SelectElem
          isClearable
          dynamic
          filterOption={() => true}
          onInputChange={handleSelectUserChange}
          placeholder="EARNING.CREATE.USER"
          options={userList}
          name={FORM_VALUE_ENUM.USER}
          onChange={onChangeUser}
          customComponents={customUserOption}
        />
        <SelectElem
          isClearable
          dynamic
          filterOption={() => true}
          onInputChange={handleSelectEventChange}
          placeholder="EARNING.CREATE.EVENT"
          options={eventList}
          name={FORM_VALUE_ENUM.EVENT}
          onChange={onChangeEvent}
        />
      </Double>
      <FieldTimeInputElem name={FORM_VALUE_ENUM.DATE} onChange={onChangeTime} />
    </Container>
  );
};

const Container = styled.div`
  display: grid;
  grid-gap: ${Spacing(3)};
  margin-bottom: ${Spacing(2)};
`;

const Double = styled.div`
  margin-top: ${Spacing(1)};
  display: flex;
  gap: ${Spacing(2)};
  width: 100%;
`;
